/**
 * Google Polyline formatını decode eden yardımcı fonksiyon
 */
export function decodePolyline(encoded: string, precision: number = 5): [number, number][] {
  const points: [number, number][] = [];
  let index = 0;
  const len = encoded.length;
  let lat = 0;
  let lng = 0;
  const factor = Math.pow(10, precision);

  while (index < len) {
    let b;
    let shift = 0;
    let result = 0;
    
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    
    const dlat = ((result & 1) !== 0 ? ~(result >> 1) : (result >> 1));
    lat += dlat;

    shift = 0;
    result = 0;
    
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    
    const dlng = ((result & 1) !== 0 ? ~(result >> 1) : (result >> 1));
    lng += dlng;

    points.push([lat / factor, lng / factor]);
  }

  return points;
}

/**
 * Tarife verilerini işleyen yardımcı fonksiyon
 */
export function processTimetables(timetables: any[]) {
  if (!timetables || timetables.length === 0) return null;

  // Tarife türlerine göre gruplandırma
  const scheduleTypes: {[key: string]: any[]} = {
    weekday: [],
    saturday: [],
    sunday: []
  };

  // Tarifeleri türlerine göre gruplandır
  timetables.forEach(timetable => {
    const type = timetable.schedule_type?.toLowerCase();
    if (type && scheduleTypes[type]) {
      scheduleTypes[type].push(timetable);
    }
  });

  // Her bir grup için saatleri çıkar
  const weekdayTimes = scheduleTypes.weekday
    .filter((timetable, index, self) => 
      index === self.findIndex(t => t.departure_time === timetable.departure_time)
    )
    .map(t => {
      // Saati uygun formata çevir (3:00:00+03:00 -> 03:00)
      const time = t.departure_time.split('+')[0];
      const [hours, minutes] = time.split(':');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    })
    .sort();

  const saturdayTimes = scheduleTypes.saturday
    .filter((timetable, index, self) => 
      index === self.findIndex(t => t.departure_time === timetable.departure_time)
    )
    .map(t => {
      const time = t.departure_time.split('+')[0];
      const [hours, minutes] = time.split(':');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    })
    .sort();

  const sundayTimes = scheduleTypes.sunday
    .filter((timetable, index, self) => 
      index === self.findIndex(t => t.departure_time === timetable.departure_time)
    )
    .map(t => {
      const time = t.departure_time.split('+')[0];
      const [hours, minutes] = time.split(':');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    })
    .sort();

  return {
    weekday: weekdayTimes,
    saturday: saturdayTimes,
    sunday: sundayTimes
  };
}
